import { GripVertical, HardHat, Trash2 } from 'lucide-react';

/**
 * Hafif bir taşeron-şoför kartı. Çalışan kartının agresif state matrix'inden
 * bilinçli olarak uzak duruyor (taşeron'larda izin/ödünç/firma kavramı yok).
 *
 * Drag payload: dataTransfer'a `subc:{id}` formatında yazılır; Planning.jsx
 * `onDropCell` bu prefix'i ayırt edip backend'e `subcontractor_id` ile POST
 * gönderir.
 */
export function SubcontractorTile({ sub, onDragStart, onDelete }) {
  const initials = (sub.full_name || '?').split(' ').slice(0, 2).map((s) => s[0]?.toUpperCase() || '').join('') || '?';
  return (
    <div
      draggable
      onDragStart={(e) => onDragStart(e, sub)}
      className="group flex items-center gap-2 px-2 py-1.5 rounded-md border border-slate-200 dark:border-slate-700 bg-amber-50/30 dark:bg-amber-900/10 hover:border-amber-300 hover:bg-amber-50 cursor-grab active:cursor-grabbing transition-colors"
      data-testid={`planning-subc-${sub.id}`}
      title={sub.note ? `${sub.full_name} · ${sub.note}` : sub.full_name}
    >
      <GripVertical className="h-3.5 w-3.5 text-slate-300 group-hover:text-amber-500 shrink-0" />
      <div className="w-7 h-7 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 text-white text-[10px] font-bold flex items-center justify-center shrink-0">
        <HardHat className="h-3.5 w-3.5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-slate-700 dark:text-slate-200 truncate">{sub.full_name}</p>
        <p className="text-[10px] font-mono text-amber-700 dark:text-amber-400 truncate">
          {sub.vehicle_code || '— plaka yok —'}
        </p>
      </div>
      <span className="text-[9px] px-1 py-0 rounded bg-amber-200 text-amber-900 font-bold uppercase tracking-tight" data-testid={`planning-subc-tag-${sub.id}`}>
        Taşeron
      </span>
      {onDelete && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onDelete(sub); }}
          className="opacity-0 group-hover:opacity-100 transition-opacity text-slate-400 hover:text-rose-500"
          title="Pasifleştir"
          data-testid={`planning-subc-delete-${sub.id}`}
        >
          <Trash2 className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
